import { createFileRoute } from "@tanstack/react-router";
import BrandPage from "@/pages/BrandPage";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/product-sunseeker/")({
  head: () => pageHead({ title: 'Sunseeker RVs', description: 'Shop Sunseeker motorhomes at Rex & Sons RVs in Castle Hayne, NC.', path: '/product-sunseeker' }),
  component: BrandPage,
});